/* eslint-disable import/no-anonymous-default-export */
import { useContext, useState} from 'react'
import { useFormik } from 'formik'
import * as Yup from "yup";
import axios from 'axios';
import { NavLink, useNavigate } from 'react-router-dom';
import styles from "./ForgetPassword.module.css"
    export default function ForgetPassword() {
        let [isLoading, setIsLoading] = useState(false);
        const [message,setMesaage] = useState("")
        const [messageError,setMessageError] = useState("");
        let navigate = useNavigate();
        function forgetPassword(values) {
            setIsLoading(true);
            axios.post(`https://ecommerce.routemisr.com/api/v1/auth/forgotPasswords`, values)
            .then(({ data }) => {
                console.log(data);
                if(data.statusMsg === "success"){
                    setMesaage(data.message);
                    setIsLoading(false);
                    setTimeout(()=> {
                        navigate("/verifyCode");
                    },1000)
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error.response?.data);
                setMessageError(`${error.response?.data?.statusMsg}: ${error.response?.data?.message}`);
            });
        }
    let validation = Yup.object({
        email: Yup.string().required('email is required').email("email not valid"),
    })
    let formik = useFormik({
        initialValues:{
        "email": "",
        },
        validationSchema: validation,
        onSubmit:forgetPassword
    })
    return (
        <>
        <div className="w-75 mt-5" style={{marginTop:"300px"}}>
            <h3>Forget Password</h3>
            {messageError.length > 0 ? <div className="alert alert-danger">{messageError}</div> : null}
            {message.length > 0 ? <div className="alert alert-success">{message}</div> : null}
            <form onSubmit={formik.handleSubmit} >

            <label htmlFor="email">Email:</label>
            <input onBlur={formik.handleBlur} className='form-control mb-2' onChange={formik.handleChange} value={formik.values.email} type="email" name="email" id="email" />
            {formik.errors.email && formik.touched.email ?<div className="alert alert-danger">{formik.errors.email}</div> : null}

            {isLoading? <button type='button' className='btn bg-success  text-white'><i className='fas fa-spinner fa-spin'></i></button> : <button disabled={!(formik.isValid && formik.dirty)} type='submit' className='btn bg-success  text-white'>Send</button>}
            </form>
        </div>
        </>
    )
    }
